import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=97777678&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=97777678&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=97777678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97777678",
  null
  
)

export default component.exports